
import { defineComponent, onMounted, computed, nextTick, ref } from "vue";
import KTTopbar from "@/layout/header/Topbar.vue";
import KTMenu from "@/layout/header/Menu.vue";
import { StickyComponent } from "@/assets/ts/components";
const dialogPolicy = ref(false);
import {
  headerWidthFluid,
  headerFixed,
  headerFixedOnMobile,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
export default defineComponent({
  name: "KTHeader",
  props: {
    title: String,
  },
  components: {
    KTTopbar,
    KTMenu,
  },
  data() {
    return {
      positionTop: document.body.scrollTop,
    };
  },
  watch: {
    $route(to, from) {
      // console.log(this.$route.path);
      if (this.$route.path.indexOf("/course/mandatory-list") == -1) {
        this.$nextTick(() => {
          setInterval(() => {
            this.positionTop = document.body.scrollTop;
          }, 500);
        });
      }
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const getProfile = async () => {
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + "/getProfile?id=" +
              localStorage.getItem("u_id"),
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        );
        if (response.status ==401) {
          localStorage.removeItem("id_token");
          router.push({ name: "login" });
        }
        // console.log(response.data.data);
        if (response.data.data.pdpaAllowed == false) {
          dialogPolicy.value = true;
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("id_token");
          router.push({ name: "login" });
        }
      }
    };
    onMounted(() => {
      if (localStorage.getItem("id_token")) {
        getProfile();
      }
      StickyComponent.reInitialization();
    });
    const isHeaderSticky = computed(() => {
      if (window.innerWidth > 768) {
        return headerFixed.value;
      } else {
        return headerFixedOnMobile.value;
      }
    });
    const changLogo = () => {
      if (route.path.indexOf("course/mandatory-list") > -1) {
        return "media/icon-app/newlogo2.png";
      } else {
        return "media/icon-app/newlogo1.png";
      }
    };
    const getClass = () => {
      if (route.path == "/home") {
        return "header-default";
      } else if (route.path == "/course/voluntary") {
        return "c-header";
      } else if (route.path == "/course/mandatory") {
        return "c-header";
      } else if (route.path == "/contactus") {
        return "c-header";
      } else if (route.path.indexOf("/blogs") > -1) {
        return "c-header";
      } else if (route.path == "/qaboard") {
        return "c-header";
      } else if (route.path.indexOf("/event") > -1) {
        return "c-header";
      } else if (route.path == "/help") {
        return "c-header";
      } else if (route.path.indexOf("course/mandatory-list") > -1) {
        return "header-mandatory";
      }
    };
    const updatePdpaAllowed = async (flg) => {
      try {
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "/updatePdpaAllowed?pdpaAllowed=" + flg,
          null,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        );
        console.log(response.data);

        if (response.data.code == 200) {
          dialogPolicy.value = false;
          getProfile();
        }
      } catch (error) {
        console.error(error);
      }
    };
    return {
      route,
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      isHeaderSticky,
      getClass,
      changLogo,
      dialogPolicy,
      updatePdpaAllowed,
      getProfile,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setInterval(() => {
        this.positionTop = document.body.scrollTop;
      }, 100);
    });
  },
  methods: {
    getClassFix() {
      if (this.positionTop > 50 && this.$route.path.indexOf("/home") > -1) {
        return "default-fix";
      } else {
        return "";
      }
    },
    getClassBg() {
      if (
        this.positionTop > 80 &&
        this.$route.path.indexOf("/course/mandatory-list") == -1
      ) {
        return "change_color";
      } else {
        return "";
      }
    },
  },
});
